module.exports = __webpack_public_path__ + "static/media/CS3 -- 1.0eae0c38.jpg";